import React from "react";
import { NavLink, useLocation } from "react-router-dom";

// Ícone de menu lateral
import { FaBars } from "react-icons/fa";

const BottomNavigation = ({ routes, onToggleSidebar }) => {
  const location = useLocation();

  const filteredRoutes = routes.filter(
    route => !route.redirect && route.showInBottom
  );

  return (
    <div className="bottom-navigation">
      {filteredRoutes.map((route, idx) => (
        <NavLink
          key={idx}
          to={route.layout + route.path}
          className={`bottom-nav-item ${
            location.pathname === route.layout + route.path ? "active" : ""
          }`}
        >
          <i className={route.icon} />
          <span>{route.name}</span>
        </NavLink>
      ))}

      {/* Botão de menu lateral */}
      <div className="bottom-nav-item" onClick={onToggleSidebar}>
        <FaBars size={18} />
        <span>Menu</span>
      </div>
    </div>
  );
};

export default BottomNavigation;
